import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getTopLevelTopics, type TopLevelTopicDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useTopic(topicId?: number): UseQueryResult<TopLevelTopicDto | undefined, AxiosError> {
    const queryKey = useMemo(() => queryKeys.topic(topicId), [topicId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getTopLevelTopics({ signal }).then((result) => result.data),
        select: (topics) => topics?.find((topic) => topic.id === topicId),
        enabled: !!topicId,
    });
}
